"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAutomatic(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M11.37982,4.654a3.34313,3.34313,0,0,0-1.78125-.6543L.03624,15.02917c-.10353.10322.02231.39618.28127.6543A.95631.95631,0,0,0,.87076,16a.141.141,0,0,0,.103-.03613L12,6.394A3.08021,3.08021,0,0,0,11.37982,4.654ZM6.788,9.59265a1.99492,1.99492,0,0,1-.37925-.38592L9.99193,5.07367a1.65229,1.65229,0,0,1,.68032.2879,1.468,1.468,0,0,1,.26318.63141Zm5.82817-7.97653L11,2.5l1.61612.88388L13.5,5l.88388-1.61612L16,2.5l-1.61612-.88388L13.5,0ZM13,7.5l-.41421,1.41421L14,8.5l1.41421.41421L15,7.5l.41421-1.41421L14,6.5l-1.41421-.41421ZM7.30287,1.2234l-.67993.87132,1.10046.10241.87132.67993L8.69713,1.7766,9.37706.90528,8.2766.80287,7.40528.12294Z' })));
}
exports.default = SvgAutomatic;
